<template>
  <div>
    <div class="title">
      <div style="display:flex;align-items:center">
        <el-date-picker v-show="isShowInput?false:true" v-model="timeRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="false" :picker-options="expireTimeOption" @change="timeChange"></el-date-picker>
        <el-select v-show="isShowInput?false:true" v-model="value" placeholder="请选择" style="margin: 0 10px;" @change="statisticsChange">
          <el-option label="按自然日统计" value="1">
          </el-option>
          <el-option label="按营业时间统计" value="2">
          </el-option>
        </el-select>
        <el-tooltip v-show="isShowInput?false:true" class="item" effect="light" placement="top-start">
          <div slot="content">
            按自然日统计：按0点到24点为一天，进行数据统计<br />
            按营业时间统计：按实际设置的营业时间为一天，进行数据统计
          </div>
          <i class="el-icon-warning" style="color:#D2D2D2;font-size:14px;"></i>
        </el-tooltip>
        <el-input v-show="isShowInput?false:true" v-model="searchInput" :placeholder="'请输入'+publicWord +(publicWord == '项目' ? '/分类' : '')+'名称'" suffix-icon="el-icon-search" style="margin-left:20px;width:220px;" @blur="searchChange" @keyup.enter.native="searchChange"></el-input>
      </div>
      <div>
        <el-button type="primary" @click="onDownload">导出报表</el-button>
        <el-button type="primary" @click="onPrint">打印报表</el-button>
      </div>
    </div>
    <br />
    <el-table v-if="update" ref="table" v-loading="loading" tooltip-effect="light" :data="data" style="width: 100%" :default-sort="defaultSort" @sort-change="sortChange">
      <!-- :sortable="item.sortable" -->
      <el-table-column v-for="(item,index) in array" :key="index" :prop="item.prop" :sortable="item.sortable" :width="(item.name == '项目名称' || item.name == '套餐名称') ? '140px' : ''" :show-overflow-tooltip="(item.name == '项目名称' || item.name == '套餐名称') ? false : true">
        <template slot="header" slot-scope="scope">
          <span v-show="scope">{{ item.name }}</span>
          <el-tooltip placement="top-start" effect="light" :content="item.tip">
            <i v-show="item.showTip" class="el-icon-warning"></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <div v-if="item.name == '项目名称'">
            <el-popover v-if="(scope.row.status == -1) || (scope.row.status == -2)" placement="bottom-start" trigger="hover">
              <p style="padding: 10px;">{{ scope.row.status == -1 ? '该项目已删除' : '该项目已下架' }}</p>
              <img v-if="scope.row.status == -1" slot="reference" class="commonTextIcon" src="static/images/icon/icon_del.png" />
              <img v-else slot="reference" class="commonTextIcon" src="static/images/icon/icon_down.png" />
            </el-popover>
            <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
              <div slot="content">
                <p>{{ scope.row.itemName }}</p>
              </div>
              <span class="commonTableShow" :style="((scope.row.status == -1) || (scope.row.status == -2)) ? 'width: 100px;' : 'width: 120px;'" @mouseover="tooltipStatus = Lib.textShow($event)">{{ scope.row.itemName }}</span>
            </el-tooltip>
          </div>
          <div v-else-if="item.name == '套餐名称'">
            <el-popover v-if="(scope.row.status == -1) || (scope.row.status == 1)" placement="bottom-start" trigger="hover">
              <p style="padding: 10px;">{{ scope.row.status == -1 ? '该套餐已删除' : '该套餐已停售' }}</p>
              <img v-if="scope.row.status == -1" slot="reference" class="commonTextIcon" src="static/images/icon/icon_del.png" />
              <img v-else slot="reference" class="commonTextIcon" src="static/images/icon/icon_stop.png" />
            </el-popover>
            <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
              <div slot="content">
                <p>{{ scope.row.vipCardName }}</p>
              </div>
              <span class="commonTableShow" :style="((scope.row.status == -1) || (scope.row.status == 1)) ? 'width: 100px;' : 'width: 120px;'" @mouseover="tooltipStatus = Lib.textShow($event)">{{ scope.row.vipCardName }}</span>
            </el-tooltip>
          </div>
          <span v-else>{{ scope.row[item.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isShowConfig" label="操作" :width="'200px'">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="onCheckDetail(scope)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  props: {
    array: {
      type: Array,
      default: Array
    },
    data: {
      type: Array,
      default: Array
    },
    changeTabs: {
      type: Boolean,
      default: Boolean
    },
    isShowConfig: {
      type: Boolean,
      default: Boolean
    },
    tableType: {
      type: String,
      default: String
    },
    isShowInput: {
      type: Boolean,
      default: Boolean
    },
    publicWord: {
      type: String,
      default: String
    },
    loading: {
      type: Boolean,
      default: Boolean
    },
    defaultSort: {
      type: Object,
      default: Object
    },
    showOnlyData: {
      type: Boolean,
      default: Boolean
    },
    dateRange: {
      type: Array,
      default: Array
    }
  },
  data() {
    return {
      timeRange: [
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      searchInput: '',
      update: true,
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        }
      },
      active_name: '',
      routerName: '',
      onlyData: true,
      tooltipStatus: false, // 气泡显示
      // 5.8
      value: '1'
    };
  },
  watch: {
    array() {
      this.update = false;
      this.$nextTick(() => {
        this.update = true;
      });
    },
    changeTabs() {
      this.timeChange([
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ]);
      this.searchChange('');
    }
  },
  activated() {
    this.timeRange = [
      dayjs()
        .subtract(30, 'day')
        .format('YYYY-MM-DD'),
      dayjs().format('YYYY-MM-DD')
    ];
  },
  methods: {
    statisticsChange(val) {
      this.$emit('statisticsChange', val);
    },
    timeChange(val) {
      this.$emit('timeChange', val);
    },
    searchChange() {
      this.$emit('searchChange', this.searchInput);
    },
    onCheckDetail(scope) {
      this.$emit('onCheckDetail', scope.row, this.timeRange, this.value);
    },
    onDownload() {
      if (this.onlyData == false) {
        this.onlyData = 1;
      } else {
        this.onlyData = 0;
      }
      if (this.$route.name === 'finance-performance') {
        if (this.Lib.checkPower('beauty-4-dcxmxssr') == false) return;
        if (this.tableType === 'classification') {
          this.$root.$children[0].fatherExport('exportItemIncome', this.timeRange[0], this.timeRange[1], this.searchInput, this.onlyData, this.value);
        } else {
          this.$root.$children[0].fatherExport('exportItemPool', this.timeRange[0], this.timeRange[1], this.searchInput, this.onlyData, this.value);
        }
      }
      if (this.$route.name === 'finance-report') {
        this.$emit('onDownload', this.value);
      }
      if (this.$route.name === 'finance-statistics') {
        if (this.Lib.checkPower('beauty-4-dctcxssr') == false) return;
        this.$root.$children[0].fatherExport('exportVipCardIncome', this.timeRange[0], this.timeRange[1], this.searchInput, this.onlyData, this.value);
      }
      if (this.$route.name === 'finance-sale') {
        if (this.Lib.checkPower('beauty-4-dckjsysr') == false) return;
        this.$root.$children[0].fatherExport('exportFastIncome', this.timeRange[0], this.timeRange[1], this.searchInput, this.value);
      }
      if (this.$route.name === 'finance-detail') {
        this.$emit('onDownload');
      }
    },
    onPrint() {
      this.$emit('onPrint', '');
    },
    // 仅看有数据
    onlyDataCheckbox(val) {
      this.$emit('onlyDataCheckbox', val);
    },
    // 排序变化
    sortChange({ prop, order }) {
      this.$emit('tableSortChange', prop, order);
    }
  }
};
</script>

<style lang="less" scoped>
.title,
.title > div {
    display: flex;
}
.title {
    justify-content: space-between;
}
</style>
